const BASE_URL = process.env.REACT_APP_TESTIVA_API_ENDPOINT;
const STM_BASE_URL = process.env.REACT_APP_API_ENDPOINT;

const getMobile = () => {
  const mobile = localStorage.getItem("mobile");
  console.log("PHONE NUMBER:", mobile);
  return mobile;
};

export const ExamBirfurcationData = async (categoryId) => {
  try {
    const response = await fetch(
      `${BASE_URL}exam-birfurcation-data?student_number=${getMobile()}&category=${categoryId}`,
      {
        method: "GET",
      }, 
    );

    return await response.json();
  } catch (err) {
    console.error("Can't fetch dashboard student exam data:", err.message);
    return null;
  }
};

export const ExamAllocationDetails = async () => {
  try {
    const response = await fetch(
      `${BASE_URL}exam-allocation-details?student_number=${getMobile()}&loadAllotHistory=true`,
      {
        method: "GET",
      },
    );
    
    return await response.json();
  } catch (err) {
    console.error("Can't fetch dashboard student exam data:", err.message);
    return null;
  }
};

export const TestivaDashboardStudentExamData = async (categoryId) => {
  try {
    const response = await fetch(
      `${BASE_URL}dashboard-student-exam-data?student_number=${getMobile()}&category_id=${categoryId}`,
      {
        method: "GET",
      },
    );

    return await response.json();
  } catch (err) {
    console.error("Can't fetch dashboard student exam data:", err.message);
    return null;
  }
};

export const TestivaDashboardStudentExamDetails = async () => {
  try {
    const response = await fetch(
      `${BASE_URL}dashboard-student-exam-details?student_number=${getMobile()}&category_id=4`,
      {
        method: "GET",
      },
    );

    return await response.json();
  } catch (err) {
    console.error("Can't fetch dashboard student exam data:", err.message);
    return null;
  }
};

export const TestivastudentAllExamData = async ({
  categoryId,
  subModule,
  questionSpecific,
}) => {
  try {
    const response = await fetch(
      `${BASE_URL}student-all-exam-data?student_number=${getMobile()}&category_id=${categoryId}&subModule=${subModule}&questionSpecific=${questionSpecific}`,
      {
        method: "GET",
      },
    );

    return await response.json();
  } catch (err) {
    console.error("Can't fetch dashboard student exam data:", err.message);
    return null;
  }
};

export const TestivaLogin = async ({ requestData }) => {
  try {
    const response = await fetch(
      `${STM_BASE_URL}testiva-integration/testiva-portal-token`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      },
    );

    return await response.json();
  } catch (err) {
    console.error("Can't fetch dashboard student exam data:", err.message);
    return null;
  }
};
